import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquarePlaceholder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-placeholder"} maskId="square-filled-radius-0-stroke-1-IconSquarePlaceholder"><path d="M21 3H3V21H21V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquarePlaceholder;
